import {Component} from '@angular/core';
import {MatCardModule} from '@angular/material/card';

@Component({
    standalone: true,
    selector: 'app-app-mobile-recette',
    templateUrl: './app-mobile-recette.component.html',
    styleUrls: ['./app-mobile-recette.component.scss'],
    imports: [MatCardModule]
})
export class AppMobileRecetteComponent {}
